import { css } from 'styled-components/macro'

const generalInput = css`
  border: 1px solid
    ${(props) =>
      props.error
        ? props.theme.colors.product.error
        : props.theme.colors.grey.grey3};
  background: ${(props) => props.theme.colors.grey.white};
  border-radius: 4px;
  padding: 12px;
  /* padding calc */
  width: calc(100% - 24px);
  min-height: calc(50px - 24px);
  outline: 0;

  font-family: 'Pluto Sans', sans-serif;
  font-size: 16px;
  line-height: 24px;

  &::placeholder {
    color: ${(props) => props.theme.colors.grey.grey5};
  }

  /* ie11 */
  @media only screen and (-ms-high-contrast: active) and (-ms-high-contrast: none) {
    min-height: 48px;
  }
`

export default generalInput
